import script from "./ScoresLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScoresLink.vue?vue&type=script&setup=true&lang=ts"

import "./ScoresLink.vue?vue&type=style&index=0&id=dcd9bc2c&scoped=scss&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcd9bc2c"]])

export default __exports__